// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/mesh-testimonials-blockchain.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Syne:wght@400..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Zen+Dots&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.6 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.tw-fixed{
  position: fixed;
}
.tw-absolute{
  position: absolute;
}
.tw-relative{
  position: relative;
}
.tw-sticky{
  position: sticky;
}
.tw-inset-0{
  inset: 0px;
}
.tw-bottom-0{
  bottom: 0px;
}
.tw-left-0{
  left: 0px;
}
.tw-left-1\\.5{
  left: 0.375rem;
}
.tw-left-12{
  left: 3rem;
}
.tw-left-3{
  left: 0.75rem;
}
.tw-left-\\[-100\\%\\]{
  left: -100%;
}
.tw-left-\\[38\\%\\]{
  left: 38%;
}
.tw-left-\\[48\\%\\]{
  left: 48%;
}
.tw-left-\\[49\\%\\]{
  left: 49%;
}
.tw-left-\\[51\\%\\]{
  left: 51%;
}
.tw-right-0{
  right: 0px;
}
.tw-right-\\[49\\%\\]{
  right: 49%;
}
.tw-top-0{
  top: 0px;
}
.tw-top-2{
  top: 0.5rem;
}
.tw-top-3{
  top: 0.75rem;
}
.tw-top-32{
  top: 8rem;
}
.tw-top-4{
  top: 1rem;
}
.tw-top-60{
  top: 15rem;
}
.tw-top-96{
  top: 24rem;
}
.tw-top-\\[20\\%\\]{
  top: 20%;
}
.tw-top-\\[25\\%\\]{
  top: 25%;
}
.tw-top-\\[30\\%\\]{
  top: 30%;
}
.tw-top-\\[35\\%\\]{
  top: 35%;
}
.tw-top-\\[40\\%\\]{
  top: 40%;
}
.tw-top-\\[45\\%\\]{
  top: 45%;
}
.tw-top-\\[50\\%\\]{
  top: 50%;
}
.tw-top-\\[55\\%\\]{
  top: 55%;
}
.tw-z-10{
  z-index: 10;
}
.tw-z-20{
  z-index: 20;
}
.tw-z-30{
  z-index: 30;
}
.tw-z-50{
  z-index: 50;
}
.tw-order-1{
  order: 1;
}
.tw-order-2{
  order: 2;
}
.tw-m-0{
  margin: 0px;
}
.tw-mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.tw-my-14{
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}
.tw-my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.tw-mb-0{
  margin-bottom: 0px;
}
.tw-mb-2{
  margin-bottom: 0.5rem;
}
.tw-mb-4{
  margin-bottom: 1rem;
}
.tw-mb-8{
  margin-bottom: 2rem;
}
.tw-ml-0{
  margin-left: 0px;
}
.tw-mt-12{
  margin-top: 3rem;
}
.tw-mt-2{
  margin-top: 0.5rem;
}
.tw-mt-3{
  margin-top: 0.75rem;
}
.tw-mt-4{
  margin-top: 1rem;
}
.tw-mt-7{
  margin-top: 1.75rem;
}
.tw-mt-8{
  margin-top: 2rem;
}
.tw-block{
  display: block;
}
.tw-inline-block{
  display: inline-block;
}
.tw-flex{
  display: flex;
}
.tw-grid{
  display: grid;
}
.tw-hidden{
  display: none;
}
.tw-h-1{
  height: 0.25rem;
}
.tw-h-10{
  height: 2.5rem;
}
.tw-h-12{
  height: 3rem;
}
.tw-h-20{
  height: 5rem;
}
.tw-h-24{
  height: 6rem;
}
.tw-h-32{
  height: 8rem;
}
.tw-h-8{
  height: 2rem;
}
.tw-h-96{
  height: 24rem;
}
.tw-h-\\[102px\\]{
  height: 102px;
}
.tw-h-\\[2px\\]{
  height: 2px;
}
.tw-h-\\[48px\\]{
  height: 48px;
}
.tw-h-\\[64px\\]{
  height: 64px;
}
.tw-h-auto{
  height: auto;
}
.tw-h-full{
  height: 100%;
}
.tw-min-h-screen{
  min-height: 100vh;
}
.tw-w-0\\.5{
  width: 0.125rem;
}
.tw-w-10{
  width: 2.5rem;
}
.tw-w-12{
  width: 3rem;
}
.tw-w-16{
  width: 4rem;
}
.tw-w-20{
  width: 5rem;
}
.tw-w-24{
  width: 6rem;
}
.tw-w-36{
  width: 9rem;
}
.tw-w-40{
  width: 10rem;
}
.tw-w-44{
  width: 11rem;
}
.tw-w-6{
  width: 1.5rem;
}
.tw-w-64{
  width: 16rem;
}
.tw-w-7{
  width: 1.75rem;
}
.tw-w-8{
  width: 2rem;
}
.tw-w-\\[100\\%\\]{
  width: 100%;
}
.tw-w-\\[102px\\]{
  width: 102px;
}
.tw-w-\\[180px\\]{
  width: 180px;
}
.tw-w-\\[2px\\]{
  width: 2px;
}
.tw-w-\\[68px\\]{
  width: 68px;
}
.tw-w-\\[80\\%\\]{
  width: 80%;
}
.tw-w-full{
  width: 100%;
}
.tw-min-w-full{
  min-width: 100%;
}
.tw--translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-cursor-pointer{
  cursor: pointer;
}
.tw-grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.tw-flex-col{
  flex-direction: column;
}
.tw-flex-wrap{
  flex-wrap: wrap;
}
.tw-items-center{
  align-items: center;
}
.tw-justify-end{
  justify-content: flex-end;
}
.tw-justify-center{
  justify-content: center;
}
.tw-justify-between{
  justify-content: space-between;
}
.tw-gap-1{
  gap: 0.25rem;
}
.tw-gap-2{
  gap: 0.5rem;
}
.tw-gap-3{
  gap: 0.75rem;
}
.tw-gap-4{
  gap: 1rem;
}
.tw-gap-5{
  gap: 1.25rem;
}
.tw-gap-7{
  gap: 1.75rem;
}
.tw-gap-8{
  gap: 2rem;
}
.tw-overflow-hidden{
  overflow: hidden;
}
.tw-overflow-x-auto{
  overflow-x: auto;
}
.tw-overflow-y-auto{
  overflow-y: auto;
}
.tw-overflow-x-hidden{
  overflow-x: hidden;
}
.tw-whitespace-nowrap{
  white-space: nowrap;
}
.tw-rounded-2xl{
  border-radius: 1rem;
}
.tw-rounded-full{
  border-radius: 9999px;
}
.tw-rounded-lg{
  border-radius: 0.5rem;
}
.tw-rounded-md{
  border-radius: 0.375rem;
}
.tw-rounded-sm{
  border-radius: 0.125rem;
}
.tw-border{
  border-width: 1px;
}
.tw-border-2{
  border-width: 2px;
}
.tw-border-b{
  border-bottom-width: 1px;
}
.tw-border-r{
  border-right-width: 1px;
}
.tw-border-t{
  border-top-width: 1px;
}
.tw-border-\\[\\#00F0FF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 240 255 / var(--tw-border-opacity));
}
.tw-border-\\[\\#2596EF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(37 150 239 / var(--tw-border-opacity));
}
.tw-border-\\[\\#2596ef\\]{
  --tw-border-opacity: 1;
  border-color: rgb(37 150 239 / var(--tw-border-opacity));
}
.tw-border-\\[\\#269FF0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(38 159 240 / var(--tw-border-opacity));
}
.tw-border-\\[\\#3C3C3C\\]{
  --tw-border-opacity: 1;
  border-color: rgb(60 60 60 / var(--tw-border-opacity));
}
.tw-border-\\[\\#456DA7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(69 109 167 / var(--tw-border-opacity));
}
.tw-border-\\[\\#515151\\]{
  --tw-border-opacity: 1;
  border-color: rgb(81 81 81 / var(--tw-border-opacity));
}
.tw-border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.tw-border-opacity-20{
  --tw-border-opacity: 0.2;
}
.tw-bg-\\[\\#0a0a0a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#141414\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 20 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#2596ef\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 150 239 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#272727\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 39 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#456DA7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(69 109 167 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#fff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.tw-bg-transparent{
  background-color: transparent;
}
.tw-bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-Mesh{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.tw-bg-button-gradient{
  background-image: linear-gradient(180deg, #2E94CB 0%, #385D94 100%);
}
.tw-bg-gradient{
  background-image: linear-gradient(90.37deg, rgba(255, 255, 255, 0.52) 10.97%, rgba(243, 243, 243, 0.29) 100%);
}
.tw-bg-contain{
  background-size: contain;
}
.tw-bg-cover{
  background-size: cover;
}
.tw-bg-center{
  background-position: center;
}
.tw-bg-no-repeat{
  background-repeat: no-repeat;
}
.tw-object-contain{
  object-fit: contain;
}
.tw-object-cover{
  object-fit: cover;
}
.tw-p-0{
  padding: 0px;
}
.tw-p-2{
  padding: 0.5rem;
}
.tw-p-4{
  padding: 1rem;
}
.tw-p-6{
  padding: 1.5rem;
}
.tw-px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.tw-px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.tw-px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.tw-px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw-px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw-px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw-px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.tw-px-9{
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.tw-py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw-py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.tw-py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.tw-py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.tw-py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.tw-py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.tw-py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.tw-py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw-py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.tw-py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.tw-py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.tw-pb-0{
  padding-bottom: 0px;
}
.tw-pb-12{
  padding-bottom: 3rem;
}
.tw-pb-2{
  padding-bottom: 0.5rem;
}
.tw-pb-28{
  padding-bottom: 7rem;
}
.tw-pb-3{
  padding-bottom: 0.75rem;
}
.tw-pb-4{
  padding-bottom: 1rem;
}
.tw-pb-5{
  padding-bottom: 1.25rem;
}
.tw-pb-8{
  padding-bottom: 2rem;
}
.tw-pl-12{
  padding-left: 3rem;
}
.tw-pr-3{
  padding-right: 0.75rem;
}
.tw-pr-5{
  padding-right: 1.25rem;
}
.tw-pt-0{
  padding-top: 0px;
}
.tw-pt-1{
  padding-top: 0.25rem;
}
.tw-pt-12{
  padding-top: 3rem;
}
.tw-pt-2{
  padding-top: 0.5rem;
}
.tw-pt-2\\.5{
  padding-top: 0.625rem;
}
.tw-pt-3{
  padding-top: 0.75rem;
}
.tw-pt-4{
  padding-top: 1rem;
}
.tw-pt-5{
  padding-top: 1.25rem;
}
.tw-pt-6{
  padding-top: 1.5rem;
}
.tw-pt-7{
  padding-top: 1.75rem;
}
.tw-text-left{
  text-align: left;
}
.tw-text-center{
  text-align: center;
}
.tw-align-bottom{
  vertical-align: bottom;
}
.tw-font-\\[Poppins\\]{
  font-family: Poppins;
}
.tw-font-poppins{
  font-family: "Poppins", sans-serif;
}
.tw-font-zen-dots{
  font-family: "Zen Dots", cursive;
}
.tw-text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.tw-text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.tw-text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.tw-text-\\[10px\\]{
  font-size: 10px;
}
.tw-text-\\[12px\\]{
  font-size: 12px;
}
.tw-text-\\[14px\\]{
  font-size: 14px;
}
.tw-text-\\[15px\\]{
  font-size: 15px;
}
.tw-text-\\[17\\.15px\\]{
  font-size: 17.15px;
}
.tw-text-\\[18px\\]{
  font-size: 18px;
}
.tw-text-\\[20px\\]{
  font-size: 20px;
}
.tw-text-\\[28px\\]{
  font-size: 28px;
}
.tw-text-\\[30px\\]{
  font-size: 30px;
}
.tw-text-\\[35px\\]{
  font-size: 35px;
}
.tw-text-\\[47px\\]{
  font-size: 47px;
}
.tw-text-\\[55px\\]{
  font-size: 55px;
}
.tw-text-\\[9px\\]{
  font-size: 9px;
}
.tw-text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw-text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw-text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw-font-bold{
  font-weight: 700;
}
.tw-font-extrabold{
  font-weight: 800;
}
.tw-font-light{
  font-weight: 300;
}
.tw-font-medium{
  font-weight: 500;
}
.tw-font-normal{
  font-weight: 400;
}
.tw-font-semibold{
  font-weight: 600;
}
.tw-uppercase{
  text-transform: uppercase;
}
.tw-capitalize{
  text-transform: capitalize;
}
.tw-leading-10{
  line-height: 2.5rem;
}
.tw-leading-3{
  line-height: .75rem;
}
.tw-leading-5{
  line-height: 1.25rem;
}
.tw-leading-7{
  line-height: 1.75rem;
}
.tw-leading-8{
  line-height: 2rem;
}
.tw-text-\\[\\#456DA7\\]{
  --tw-text-opacity: 1;
  color: rgb(69 109 167 / var(--tw-text-opacity));
}
.tw-text-\\[\\#A4B4C3\\]{
  --tw-text-opacity: 1;
  color: rgb(164 180 195 / var(--tw-text-opacity));
}
.tw-text-\\[black\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-opacity-100{
  opacity: 1;
}
.tw-opacity-75{
  opacity: 0.75;
}
.tw-shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tw-backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw-transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw-transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw-duration-300{
  transition-duration: 300ms;
}
.tw-duration-500{
  transition-duration: 500ms;
}


*{font-family: "Syne", sans-serif;
  
  

}
body{
  overflow-x: hidden !important;
}


a{
  text-decoration: none !important;
}


.gradient-text {
  background: linear-gradient(90deg, #27F2FF 0%, #3276E9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}



.border-gradient {
  border-width: 2.14px;
  border-image-source: linear-gradient(86.91deg, #77D9FF 8.72%, #3091EE 94.71%);
  border-image-slice: 1;
  border-radius:1%;
}

.bg-hero-cut {
  background-size: cover;
  background-position: center;
  

}

.hover\\:tw-bg-button-gradient:hover{
  background-image: linear-gradient(180deg, #2E94CB 0%, #385D94 100%);
}

@media (min-width: 640px){
  .sm\\:tw-static{
    position: static;
  }
  .sm\\:tw-relative{
    position: relative;
  }
  .sm\\:tw-order-1{
    order: 1;
  }
  .sm\\:tw-order-2{
    order: 2;
  }
  .sm\\:tw-my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .sm\\:tw-block{
    display: block;
  }
  .sm\\:tw-inline-block{
    display: inline-block;
  }
  .sm\\:tw-flex{
    display: flex;
  }
  .sm\\:tw-hidden{
    display: none;
  }
  .sm\\:tw-h-\\[94px\\]{
    height: 94px;
  }
  .sm\\:tw-h-screen{
    height: 100vh;
  }
  .sm\\:tw-w-\\[101px\\]{
    width: 101px;
  }
  .sm\\:tw-w-auto{
    width: auto;
  }
  .sm\\:tw-justify-start{
    justify-content: flex-start;
  }
  .sm\\:tw-gap-6{
    gap: 1.5rem;
  }
  .sm\\:tw-bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
  .sm\\:tw-pb-0{
    padding-bottom: 0px;
  }
  .sm\\:tw-pb-32{
    padding-bottom: 8rem;
  }
  .sm\\:tw-pt-2{
    padding-top: 0.5rem;
  }
  .sm\\:tw-text-start{
    text-align: start;
  }
  .sm\\:tw-align-middle{
    vertical-align: middle;
  }
  .sm\\:tw-text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:tw-text-\\[14px\\]{
    font-size: 14px;
  }
  .sm\\:tw-text-\\[16px\\]{
    font-size: 16px;
  }
  .sm\\:tw-text-\\[18px\\]{
    font-size: 18px;
  }
  .sm\\:tw-text-\\[20px\\]{
    font-size: 20px;
  }
  .sm\\:tw-text-\\[40px\\]{
    font-size: 40px;
  }
  .sm\\:tw-text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:tw-text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:tw-text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px){
  .md\\:tw-absolute{
    position: absolute;
  }
  .md\\:tw-sticky{
    position: sticky;
  }
  .md\\:-tw-left-24{
    left: -6rem;
  }
  .md\\:tw-ml-24{
    margin-left: 6rem;
  }
  .md\\:tw-block{
    display: block;
  }
  .md\\:tw-w-\\[60\\%\\]{
    width: 60%;
  }
  .md\\:tw-px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .md\\:tw-pt-32{
    padding-top: 8rem;
  }
  .md\\:tw-text-start{
    text-align: start;
  }
  .md\\:tw-text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:tw-text-\\[45px\\]{
    font-size: 45px;
  }
}

@media (min-width: 1024px){
  .lg\\:tw-flex{
    display: flex;
  }
  .lg\\:tw-hidden{
    display: none;
  }
}



`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;AAGnB,EAAE,+BAA+B;;;;AAIjC;AACA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,gCAAgC;AAClC;;;AAGA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;AACtC;;;;AAIA;EACE,oBAAoB;EACpB,6EAA6E;EAC7E,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;;;AAG7B;;AA3CA;EAAA;AA+CA;;AA/CA;EAAA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA,gBA+CA;IA/CA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA,kBA+CA;IA/CA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA,mBA+CA;IA/CA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA,eA+CA;IA/CA;EA+CA;EA/CA;IAAA,mBA+CA;IA/CA;EA+CA;EA/CA;IAAA,kBA+CA;IA/CA;EA+CA;AAAA;;AA/CA;EAAA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA,kBA+CA;IA/CA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;EA/CA;IAAA,eA+CA;IA/CA;EA+CA;EA/CA;IAAA;EA+CA;AAAA;;AA/CA;EAAA;IAAA;EA+CA;EA/CA;IAAA;EA+CA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400..800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Zen+Dots&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n*{font-family: \"Syne\", sans-serif;\n  \n  \n\n}\nbody{\n  overflow-x: hidden !important;\n}\n\n\na{\n  text-decoration: none !important;\n}\n\n\n.gradient-text {\n  background: linear-gradient(90deg, #27F2FF 0%, #3276E9 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n\n\n.border-gradient {\n  border-width: 2.14px;\n  border-image-source: linear-gradient(86.91deg, #77D9FF 8.72%, #3091EE 94.71%);\n  border-image-slice: 1;\n  border-radius:1%;\n}\n\n.bg-hero-cut {\n  background-size: cover;\n  background-position: center;\n  \n\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
